module.exports = __webpack_public_path__ + "media/audio9.153b1b0a.mp3";